import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './permission'
import store from './store'
import common from './utils/evaluats'
import service from './utils/service'
import '@/utils/filter'
import '@/elementui/index'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'vue-color/vue2/style.css'
import 'github-markdown-css'
import '@/styles/index.scss'
import confirmModal from '@/components/common/ConfirmModal/index'
import editModal from '@/components/common/EditModal/index'
import evaluateModal from '@/components/test/EvaluateModal'
import wordModal from '@/components/modal/WordModal'
import webVersion from '@/version.json'

console.info('内置web版本信息', webVersion)

// ant-design-vue
Vue.use(Antd)

const dayjs = require('dayjs')
const duration = require('dayjs/plugin/duration')
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
dayjs.extend(duration)
Vue.prototype.$dayjs = dayjs

import bus from '@/bus'
Vue.prototype.$bus = bus

// lodash工具类
import _ from 'lodash'
Vue.prototype.$_ = _
Vue.prototype.common = common
Vue.prototype.$service = service
Vue.prototype.$confirmModal = confirmModal
Vue.prototype.$editModal = editModal
Vue.prototype.$evaluateModal = evaluateModal
Vue.prototype.$wordModal = wordModal

Vue.config.productionTip = false

// 自定义指令
import directive from '@/directive/index'
Vue.use(directive)

// 节流技术
let flag = false
Vue.prototype.$throttle = function (callBack, wait = 300) {
  if (!flag) {
    flag = true
    setTimeout(() => {
      callBack()
      flag = false
    }, wait)
  }
}
// 防抖
let debounceObj = null
Vue.prototype.$debounce = function (time, callBack) {
  if (debounceObj) {
    clearTimeout(debounceObj)
  }
  debounceObj = setTimeout(() => {
    callBack()
    debounceObj = null
  }, time)
}

import MyTitle from '@/components/common/MyTitle.vue'
import Footer from '@/components/common/Footer.vue'
import ActivationCode from '@/components/vip/ActivationCode.vue'
import Sidebar from '@/components/common/Sidebar.vue'
Vue.component('MyTitle', MyTitle)
Vue.component('Footer', Footer) // eslint-disable-line vue/multi-word-component-names
Vue.component('ActivationCode', ActivationCode)
Vue.component('Sidebar', Sidebar) // eslint-disable-line vue/multi-word-component-names

import '@/components/SvgIconV2/SvgIconV2.js'
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue'
import XYButtonV2 from '@/components/common/XYButtonV2.vue'
import XYDialog from '@/components/common/XYDialog.vue'
Vue.component('SvgIcon', SvgIcon)
Vue.component('XYButtonV2', XYButtonV2)
Vue.component('XYDialog', XYDialog)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
